import { AddButton } from '@/common/buttons/AddButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const ProgList = ({ ctrtObj }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!ctrtObj) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('ctrtId', ctrtObj.id));
  }, [ctrtObj?.id]);

  const augNavEntityObj = useCallback((navEntityObj) => {
    navEntityObj.startDate = ctrtObj?.startDate;
    navEntityObj.endDate = ctrtObj?.endDate
  }, [ctrtObj?.startDate, ctrtObj?.endDate]);

  const augTabButtons = useCallback((tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    if (ctrtObj?.status !== 'IMPL') {
      tabButtons.push(<AddButton entity="PROG" augNavEntityObj={augNavEntityObj}/>);
    }
  }, [augNavEntityObj]);
  
  return (
    <EntityList entity="PROG" augRowsReq={augRowsReq} augTabButtons={augTabButtons}/>
  )
}
